import React from 'react';
import { mountOn } from './lib/mount';
import { showToast } from './lib/toast';
import { DocumentsView } from './components/documents';

mountOn('documents-test-root',
  <DocumentsView
    onOpenDoc={() => {}}
    onNewDoc={() => {}}
    onToast={showToast}
  />
);
